import generalTranslations from './general';
import widgetCustomization from './widget';
import officeHours from './officeHours';
import mutual from './mutual';
import emailSettings from './email';
import autoMessage from './autoMessage';
import responseDelay from './responseDelay';
import formGenerator from './formGenerator';
import responsiveRobot from './responsiveRobot';

const translations = {
  ...generalTranslations,
  ...widgetCustomization,
  ...emailSettings,
  ...officeHours,
  ...mutual,
  ...autoMessage,
  ...responseDelay,
  ...formGenerator,
  ...responsiveRobot,
};

export default translations;
